








































































































import * as ent from '@/entities';
import { MasterPageCriteria } from '@/components/base/master/master-page-criteria';

import * as types from '@/store/types';

import Component from 'vue-class-component';
import accountsApi from '@/api/accounts.api';

@Component({})
export default class AgentsApprove extends MasterPageCriteria {
    public items: ent.IAccount[] = [];

    protected defaultSort: ent.ISort = {
        field: 'username',
        asc: true
    };

    public created() {
        this.search();
    }

    public async list(
        body: ent.ISearchBody
    ): Promise<ent.IPaging<ent.IAccount>> {
        const accounts = await accountsApi.unapproved({
            sortField: body.sortField,
            sortAsc: body.sortAsc
        });
        return ent.withPaging(accounts);
    }

    public approve(item: ent.IAccount) {
        this._approveItems([item.id], 'Are you sure to approve agent?');
    }

    public approveSelected() {
        this._approveItems(
            [...this.selected],
            'Are you sure to approve selected agents?'
        );
        this.selected = [];
    }

    public migrate() {
        let afterFn = async (closeFn: () => void) => {
            try {
                await accountsApi.migrate();
                this.$router.push('/app/agents');
            } finally {
                closeFn();
            }
        };
        let payload: ent.IConfirm = {
            heading:
                'Do you want to migrate old agents from old server, marked as "Ready To Migrate"?',
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);
    }

    private _approveItems(ids: number[], alertText: string = null) {
        let afterFn = async (closeFn: () => void) => {
            try {
                await accountsApi.approveBatch(ids);
                this.$store.dispatch(types.APPROVE_QUERY_UNAPPROVED_COUNT);
                this.items = this.items.filter((x) => ids.indexOf(x.id) === -1);
            } finally {
                closeFn();
            }
        };
        let payload: ent.IConfirm = {
            heading: alertText,
            afterFn
        };

        this.$store.dispatch(types.SHOW_CONFIRM, payload);

    }
}
